import { render, staticRenderFns } from "./PrintInsalubrity.vue?vue&type=template&id=a06ed0f6&scoped=true&"
import script from "./PrintInsalubrity.vue?vue&type=script&lang=js&"
export * from "./PrintInsalubrity.vue?vue&type=script&lang=js&"
import style0 from "./PrintInsalubrity.vue?vue&type=style&index=0&id=a06ed0f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06ed0f6",
  null
  
)

export default component.exports